import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgTermsOfUse(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46.87 90.304c-.94 0-1.702-.807-1.702-1.802V30.858c0-.995.761-1.802 1.701-1.802.94 0 1.702.807 1.702 1.802v57.644c0 .995-.762 1.802-1.702 1.802Z"
        fill="#599F40"
      />
      <path
        d="M17.947 30.758c0-.94.762-1.702 1.701-1.702H74.09a1.701 1.701 0 0 1 0 3.403H19.648c-.94 0-1.701-.762-1.701-1.701Z"
        fill="#599F40"
      />
      <path
        d="M21.35 31.36c.411 0 .79.23.978.596l12.25 23.818a1.1 1.1 0 0 1-1.957 1.006L21.349 34.863 10.08 56.78a1.1 1.1 0 0 1-1.957-1.006l12.25-23.818.079-.13a1.1 1.1 0 0 1 .898-.467ZM72.388 31.36c.413 0 .79.23.979.596l12.25 23.818a1.1 1.1 0 0 1-1.957 1.006L72.388 34.863 61.118 56.78a1.1 1.1 0 0 1-1.957-1.006l12.25-23.818.079-.13a1.1 1.1 0 0 1 .898-.467Z"
        fill="#0F172A"
      />
      <path
        d="M7.739 55.143H34.96c0 7.517-6.094 13.61-13.61 13.61-7.517 0-13.611-6.093-13.611-13.61Z"
        fill="#007A5F"
      />
      <path
        d="M27.5 62.686a.8.8 0 0 1 1.058 1.2 10.283 10.283 0 0 1-5.64 2.51.8.8 0 0 1-.184-1.588 8.686 8.686 0 0 0 4.766-2.122Zm2.494-3.742a.8.8 0 0 1 1.515.517c-.09.263-.19.522-.3.777a.8.8 0 0 1-1.468-.636 8.68 8.68 0 0 0 .253-.658Z"
        fill="#fff"
      />
      <path
        d="M58.778 55.143H86c0 7.517-6.093 13.61-13.61 13.61-7.517 0-13.61-6.093-13.61-13.61Z"
        fill="#007A5F"
      />
      <path
        d="M44.034 29.056v-.283c0-1.723 1.27-3.12 2.835-3.12 1.566 0 2.836 1.397 2.836 3.12v.283h-5.671ZM44.034 86.901v-.85c0-1.41 1.27-2.553 2.835-2.553 1.566 0 2.836 1.143 2.836 2.552v.851h-5.671ZM31.558 93.706a6.805 6.805 0 0 1 6.805-6.805h17.013a6.805 6.805 0 0 1 6.805 6.805H31.558Z"
        fill="#599F40"
      />
      <path d="M57.778 68.186a5.104 5.104 0 1 1 10.208 0v1.702H57.778v-1.702Z" fill="#CCD5E1" />
      <path
        d="M67.419 95.407v-27.22a5.104 5.104 0 0 0-5.104-5.104H92.94a5.104 5.104 0 0 1 5.104 5.103v27.221a5.104 5.104 0 0 0 5.104 5.104H72.523a5.104 5.104 0 0 1-5.104-5.104Z"
        fill="#F1F5F9"
      />
      <path
        d="M66.619 95.408V68.186a4.304 4.304 0 0 0-4.304-4.304.8.8 0 1 1 0-1.6 5.904 5.904 0 0 1 5.904 5.904v27.222a.8.8 0 0 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M108.818 95.407a5.104 5.104 0 0 1-5.104 5.104H73.09a5.104 5.104 0 0 0 5.104-5.103v-1.702h30.624v1.701Z"
        fill="#CCD5E1"
      />
      <path
        d="M91.124 83.379a.8.8 0 0 1 0 1.6H75.472a.8.8 0 1 1 0-1.6h15.652Zm0-4.537a.8.8 0 0 1 0 1.6H75.472a.8.8 0 0 1 0-1.6h15.652Zm0-4.536a.8.8 0 0 1 0 1.6H75.472a.8.8 0 0 1 0-1.6h15.652Zm0-4.537a.8.8 0 0 1 0 1.6H75.472a.8.8 0 1 1 0-1.6h15.652Z"
        fill="#B3C0D0"
      />
      <path
        d="M86.473 21.264a1.816 1.816 0 0 1 1.95-1.193c5.258.673 10.344.982 11.97 1.07.352.019.686.136.973.34 1.324.947 5.49 3.883 10.016 6.642a1.815 1.815 0 0 1 .778 2.149l-4.242 12.097c-2.692 7.677-14.094 10.197-17.367 10.77a1.592 1.592 0 0 1-1.483-.52c-2.199-2.492-9.53-11.58-6.837-19.258l4.242-12.097Z"
        fill="#78B441"
      />
      <path
        d="M104.099 38.866a8.847 8.847 0 1 1-16.697-5.856 8.847 8.847 0 0 1 16.697 5.856Z"
        fill="#E6F4F0"
      />
      <path
        d="M99.083 34.972a.8.8 0 0 1 .694 1.442l-5.205 2.502a.8.8 0 0 1-1.068-.375l-1.667-3.469a.8.8 0 0 1 1.441-.694l1.322 2.748 4.483-2.154Z"
        fill="#78B441"
      />
    </svg>
  )
}
export default wrapIllustration(SvgTermsOfUse)
